import config from 'SRC/config/config.yaml'

export const languageVersions = config.languageVersions
